import React, {Component} from 'react'
import {Accordion, Divider, Header, Icon, Segment, Button, Label} from 'semantic-ui-react'
import CageTraining from "./CageTraining";
import TrainingFeed from "./TrainingFeed";

export default class TrainingAccordion extends Component {
    state = {
        activeIndex: 0
    };

    handleClick = (index) => {
        const {activeIndex} = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({activeIndex: newIndex})
    };

    render() {
        const {activeIndex} = this.state;
        const {cageTrainings, postEvent, onCancel} = this.props;

        return (
            <Accordion>
                {cageTrainings.map((training, index) => {
                    const isActive = activeIndex === index;
                    const cageDateTime = new Date(training.time)
                    return ([
                        <Segment key={training.id} clearing
                                 className={training.cancelled ? "accordion-finished" : undefined}>
                            <Accordion.Title onClick={() => this.handleClick(index)}>
                                <Header as='h3'>
                                    <Icon name={isActive ? 'chevron down' : 'chevron right'}/>
                                    <Header.Content>
                                        Cageballtrening
                                        - {cageDateTime.toLocaleDateString()} {cageDateTime.toLocaleTimeString()} {training.cancelled &&
                                        <Label color="red" size="large">AVLYST</Label>}
                                    </Header.Content>
                                    <Header.Subheader>{training.participants.filter(p => p.state === "ATTENDING").length} påmeldte</Header.Subheader>
                                </Header>
                            </Accordion.Title>
                            <Accordion.Content active={isActive}>
                                <CageTraining key={training.id} training={training} postEvent={postEvent}/>
                                {training.feedEntries.length ? <Divider horizontal>Feed</Divider> : null}
                                <TrainingFeed entries={training.feedEntries}/>
                                {training.cancelled && window.location.search.endsWith("dashboard") && <Button
                                    basic
                                    size="tiny"
                                    color="green"
                                    onClick={() => postEvent({
                                        type: 'RESCHEDULE_TRAINING',
                                        cageTrainingId: training.id,
                                    })}
                                    floated="right"
                                >
                                    Fjern avlysning
                                </Button>}
                                {training.cancelled && window.location.search.endsWith("dashboard") && <Button
                                    basic
                                    size="tiny"
                                    onClick={() => postEvent({
                                        type: 'REMOVE_BEER_PUNISHMENT',
                                        cageTrainingId: training.id,
                                    })}
                                    floated="right"
                                >
                                    Ingen ølstraff
                                </Button>}
                                {!training.cancelled && <Button
                                    basic
                                    size="tiny"
                                    color="red"
                                    onClick={() => onCancel(training.id)}
                                    floated="right"
                                >
                                    Avlys trening
                                </Button>}
                            </Accordion.Content>
                        </Segment>
                    ]);
                })}
            </Accordion>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/TrainingAccordion.js